import $i18n from "@/utils/i18n"
import authService from "@/services/auth";

export const state = {
  language: "en",
};

export const actions = {
  setLanguageAction({ commit }, data) {
    commit("setLanguage", data);
  },
  changeLanguage({ commit }, data) {
    commit("setLanguage", data);
    return new Promise((resolve, reject) => {
      authService
      .changeLanguage(data)
      .then((data) => {
          resolve(data);
          // this._vm.$toast.success(data.message);
      })
      .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.message);

      });
    });
  },
};

export const mutations = {
  setLanguage(state, data) {
    console.log('setLanguage data', data);
    $i18n.locale = data;
    state.language = data;
  },
};

export const getters = {
  getLanguage(state) {
    return state.language;
  },
};
